import React from 'react';
import { Fab, Tooltip, Badge, Zoom } from '@mui/material';
import { Help as HelpIcon } from '@mui/icons-material';
import { useHelpContext } from '../../contexts/HelpWidgetContext';

interface HelpButtonProps {
  showBadge?: boolean;
  badgeContent?: number;
}

export const HelpButton: React.FC<HelpButtonProps> = ({
  showBadge = false,
  badgeContent = 0,
}) => {
  const { toggleHelp, isOpen } = useHelpContext();

  return (
    <Zoom in={!isOpen}>
      <Tooltip title="Help (Cmd+/)" placement="left">
        <Badge
          badgeContent={showBadge ? badgeContent : 0}
          color="error"
          invisible={!showBadge || badgeContent === 0}
        >
          <Fab
            color="primary"
            onClick={toggleHelp}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: (theme) => theme.zIndex.drawer - 1,
            }}
          >
            <HelpIcon />
          </Fab>
        </Badge>
      </Tooltip>
    </Zoom>
  );
};

export default HelpButton;
